"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.convertSlotChildren = exports.getChildrenVNode = void 0;

var _flattenDeep = _interopRequireDefault(require("lodash/flattenDeep"));

var getChildrenVNode = function getChildrenVNode(vnode, conditionFn) {
  if (vnode) {
    if (Array.isArray(vnode)) {
      return (0, _flattenDeep.default)(vnode.map(function (childNode) {
        return getChildrenVNode(childNode, conditionFn);
      }));
    } else if (vnode.children) {
      return vnode.children.filter(conditionFn);
    }
  }

  return [];
};

exports.getChildrenVNode = getChildrenVNode;

var convertSlotChildren = function convertSlotChildren(slots, h, names) {
  if (!names.length) {
    return [];
  }

  var children = [];
  names.forEach(function (name) {
    var slotNode = slots[name];

    if (slotNode) {
      children.push(h('template', {
        slot: name
      }, [slotNode]));
    }
  });
  return children;
};

exports.convertSlotChildren = convertSlotChildren;